import { Button, Stack, Text, Title } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import dayjs from "dayjs";

import { WarningIcon } from "../../components/WarningIcon/WarningIcon";

export function CheckInCancel({ cancelDate }: { cancelDate: string }) {
  const navigate = useNavigate();
  /* const formattedDate = dayjs(cancelDate).format("DD/MM [às] HH:mm"); */
  const formattedDate = dayjs().format("DD/MM [às] HH:mm");

  return (
    <>
      <Stack gap="md">
        <div className="flex flex-col items-center gap-2">
          <WarningIcon size={64} />
          <Title c="red">Atenção!</Title>
        </div>

        <Stack gap="md" className="text-center">
          <Text>Você acaba de sair da fila. Por esse motivo seu check-in será cancelado.</Text>

          <Text size="lg" fw="bold">
            Check-in cancelado em {formattedDate}
          </Text>

          <Text ta="justify">Para ser atendido é necessário retornar para ao pátio da empresa, acessar o WIFI disponível e refazer o check-in.</Text>
        </Stack>
      </Stack>

      <Button onClick={() => navigate({ to: "/app" })} fullWidth>
        Ok
      </Button>
    </>
  );
}
